import { AxiosRequestConfig } from 'axios';
import { axiosInstanceWithToken } from 'utils/axios';
import { ICSVCreateRequest } from '../../server/types';

export const uploadFile = async (data: FormData, config: AxiosRequestConfig) =>
  axiosInstanceWithToken().post('files/upload', data, config);

export const createCSV = async (data: ICSVCreateRequest) => axiosInstanceWithToken().post('files/csv', data);
